import { Observable } from 'rxjs';
import { SmoLanguage } from '../../Models/Smo/SmoLanguage';
import { SmoMoon } from '../../Models/Smo/SmoMoon';
import { Optional } from '../../Utils/Types';
import { Request } from '../Request/Request';
import { MoonPrediction } from './Models/MoonPrediction';
import { MoonManager } from './MoonManager';

export class SmoMoonManager implements MoonManager {
  public searchMoonWithName(name: string, language: SmoLanguage): Observable<SmoMoon[]> {
    return new Request().withPath('/moon/search').withParams({ s: name, l: language }).get();
  }

  public predictMoonWithName(name: string, language: SmoLanguage): Observable<Optional<MoonPrediction>> {
    return new Request().withPath('/moon/predict').withParams({ n: name, l: language }).get();
  }
}
